module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Model_Backlinks Widget

(function (fox, $) {

	var _ = {
		toggleElement: function (hide) {
			if (hide === true) {
				if (this._indom) {
					$(this.element).hide();
				} else {
					this.waitEvent(this, 'addedToDom', fox.bind(function () {
						_.toggleElement.call(this, true);
					}, this));
				}
			} else {
				if (this._indom) {
					if (!$(this.element).is(':visible')) {
						$(this.element).show();
					}
				} else {
					this.waitEvent(this, 'addedToDom', fox.bind(function () {
						_.toggleElement.call(this);
					}, this));
				}
			}
		}
	}
	
	fox.registerWidget('Model_Backlinks', {

		configure: function () {
			this.registerOptions('', {
				'embed.container': '#model-backlinks',
				template: 'model_backlinks_container',				
				autoRender: true,
				externalLoad: true,
				templateOptions: {
					starringTitle: 'Starring'
				},
				widgets: {
					dl: {
						widget: 'Datalayer',
						method: 'model.getModelContent'
					},
					modelStNames: {
						widget: 'Grid_List',
						'tpl.row': 'model_starring',
						'embed.container': '#st-list'
					},
					modelBacklinks: {
						widget: 'Grid_List',
						'tpl.row': 'model_back_links',
						'embed.container': '#back-links'
					}
				},
				fireEventWidget: '@parent',
				listenEventName: 'setContentId',
				'handleWom.addToDom': {
					event: 'addedToDom',
					widget: '@this',
					callback: '_hideTemplate'
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.callParent('init', arguments);

			fox.each(this.rwom('.Grid_List'), function (w) {
				this.registerOptions('#' + w.getAlias(), {
					dataLayer: this.dl
				})
			}, this);

			this.handleEvent(
				this.getOption('fireEventWidget'), 
				this.getOption('listenEventName'), 
				'_loadCollection'
			);

			this.handleEvent(this.dl, 'loaded', '_hideTemplate');
		},

		_loadCollection: function (contentId) {
			this
				.dl
				.setTransitParameter('contentId', contentId)
				.load();
		},

		_hideTemplate: function () {
			if (!this.dl.getCount()) {
				_.toggleElement.call(this, true);
			} else {
				_.toggleElement.call(this);
			}
		}

	}, 'Grid');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/modelBacklinks.js
// module id = 887
// module chunks = 4